import { useMemo } from 'react';
// components
import {
  CasEditForm,
  IEditForm,
  CasRHFPercentField,
  CasRHFSelect,
} from 'src/compass/shared/components';

import { formatDate, DateFormat, getDateMonth, getDateYear } from 'src/compass/shared/util/casMoment';
import { useFirstOfMonthDateOptions, CasRHFRiskManagerSelect } from 'src/compass/application';
import { EntityInfoLRPAccelerated } from 'src/compass/application/commissions';
// schema
import { AcceleratedSchema } from './LrpCommissionsSchema';
import { useAcceleratedCountInvalidate } from '../useAcceleratedCount';

// ----------------------------------------------------------------------

export default function LRPAcceleratedForm({ row, onSaved: propertyOnSaved }: IEditForm) {
  const { id } = row || {};

  const invalidateAcceleratedCount = useAcceleratedCountInvalidate()
  
  const months = useFirstOfMonthDateOptions({
    numberOfMonths: 12,
    format: DateFormat.MYM,
  });

  const defaultValues = useMemo(
    () =>
      id
        ? {
            ...row,
            monthYear: formatDate({ year: row.year, month: row.month - 1 }, DateFormat.YMD),
          }
        : {},
    [id, row]
  );

  const onBeforeSave = (data: any) => ({
    ...data,
    month: getDateMonth(data.monthYear),
    year: getDateYear(data.monthYear),
  });

  const onSaved = (data: any) => {
    invalidateAcceleratedCount();
    propertyOnSaved(data);
  };

  return (
    <CasEditForm
      defaultValues={defaultValues}
      onBeforeSave={onBeforeSave}
      onSaved={onSaved}
      entity={EntityInfoLRPAccelerated.entity}
      schema={AcceleratedSchema}
    >
      <CasRHFSelect
        name="monthYear"
        label="Month/Year"
        options={months}
        optionsIdField="value"
        optionsNameField="label"
      />

      <CasRHFRiskManagerSelect name="employeeId" label="Agent" />
      <CasRHFPercentField name="percent" label="Percent" />
    </CasEditForm>
  );
}
